import { CommonModule, Location } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { User } from '../../interfaces/user.interface';
import { Position } from '../../../components/profile/enums/position.enum';
import { environment } from '../../../../environments/environment';
import { CopyClipboardDirective } from '../../directives/copy-clipboard.directove';

@Component({
  selector: 'app-member-detail',
  templateUrl: './member-detail.component.html',
  styleUrls: ['./member-detail.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    CopyClipboardDirective
  ]
})
export class MemberDetailComponent implements OnInit {
  private readonly userService = inject(UserService);
  private readonly location = inject(Location);
  private readonly route = inject(ActivatedRoute);

  user!: User;
  currentUser!: User | null;
  POSITIONS = Position;
  api = environment.apiUrl;

  constructor() { }

  ngOnInit() {
    // Get current logged-in user
    this.userService.currentUser.subscribe(user => {
      this.currentUser = user;
    });

    const id = this.route.snapshot.params['id'];
    this.userService.getMemberDetails(id)
    .subscribe((res: any) => {
      this.user = res;
    });
  }

  goBack() {
    this.location.back();
  }

  // Check if both users are industry and visibility is restricted
  shouldShowPhone(): boolean {
    if (!this.user || !this.currentUser) return false;
    // If both are industry users, respect visibility settings
    if (this.user.status === 'industry' && this.currentUser.status === 'industry') {
      return this.user.settings?.phoneVisible !== false; // Default to true if not set
    }
    // Non-industry users can see everything
    return true;
  }

  shouldShowEmail(): boolean {
    if (!this.user || !this.currentUser) return false;
    if (this.user.status === 'industry' && this.currentUser.status === 'industry') {
      return this.user.settings?.emailVisible !== false;
    }
    return true;
  }

  shouldShowSocials(): boolean {
    if (!this.user || !this.currentUser) return false;
    if (this.user.status === 'industry' && this.currentUser.status === 'industry') {
      return this.user.settings?.socialsVisible !== false;
    }
    return true;
  }

}
